/**
 * Client-side environment access.
 *
 * Vite exposes only `VITE_*` variables to the browser via `import.meta.env`.
 * Keep all reads funnelled through small helpers: values the app cannot run
 * without fail loudly (with a clear message), while cosmetic values degrade
 * to an empty string rather than crash the app.
 */

/**
 * Base URL for the reipm-api Hono app. Already includes the `/api/v2` mount
 * prefix (see `reipm-api/src/index.ts` → `.route('/api/v2', api)`), so it is
 * used directly as the `hc<AppType>()` base — no extra path is appended.
 *
 * Dev: `http://localhost:4002/api/v2`.
 */
export const getClientApiUrl = (): string => {
  const apiUrl = import.meta.env.VITE_API_URL;
  if (!apiUrl) {
    throw new Error('VITE_API_URL is not defined. Add it to your .env file.');
  }
  return apiUrl;
};

/** Support email shown in the Report Bugs/Issues dialog (ASE team inbox). */
export const getAseEmail = (): string => {
  return import.meta.env.VITE_EMAIL_ASE ?? '';
};

/** WhatsApp support number (E.164, with leading `+`) for the Report Bugs/Issues dialog. */
export const getWhatsappNumber = (): string => {
  return import.meta.env.VITE_WHATSAPP_NUMBER ?? '';
};
